export const ImageGalleryPermissions = {
  ViewAndSearchImagesGallery: {
    components: null,
    componentsId: null,
    permissionsId: '041a563a-2d8b-4c51-ca8e-08d968898511',
    permissionsName: 'View and Search Images  Gallery'

  },
  ViewAndFilterOnAlbumImages: {
    components: null,
    componentsId: null,
    permissionsId: 'a20a492a-3314-4759-ca8f-08d968898511',
    permissionsName: 'View and filter on album images'
  },
  UpdateAlbum: {
    components: null,
    componentsId: null,
    permissionsId: 'a6944b31-ab60-4294-ca90-08d968898511',
    permissionsName: 'Update Album'
  },
  CreateNewAlbum: {
    components: null,
    componentsId: null,
    permissionsId: '276c5bd7-b28e-47a6-ca91-08d968898511',
    permissionsName: 'Create New Album'

  },

  DeleteAlbum: {
    components: null,
    componentsId: null,
    permissionsId: '0c47a47f-8e45-4faa-ca92-08d968898511',
    permissionsName: 'Delete Album'
  }

};
